import React from 'react'
import { useTranslation } from 'react-i18next'
import { UilLayersAlt } from '@iconscout/react-unicons'

const MaterialInfo = ({
  selectedOperatorAdditiveMaterialForInfo,
  selectedOperatorAdditiveMaterialIds,
  operatorAdditiveMaterialsData = [],
}) => {
  const { t } = useTranslation()

  let displayMaterial = selectedOperatorAdditiveMaterialForInfo
  let multipleSelectedForMappingCount = 0

  if (
    !displayMaterial &&
    selectedOperatorAdditiveMaterialIds &&
    selectedOperatorAdditiveMaterialIds.size > 0
  ) {
    const firstSelectedId = Array.from(selectedOperatorAdditiveMaterialIds)[0]
    displayMaterial = operatorAdditiveMaterialsData.find(
      (material) => material.id === firstSelectedId,
    )
    if (selectedOperatorAdditiveMaterialIds.size > 1) {
      multipleSelectedForMappingCount =
        selectedOperatorAdditiveMaterialIds.size - 1
    }
  }

  if (!displayMaterial) {
    return (
      <>
        <h4>{t('material_info_title_placeholder')}</h4>
      </>
    )
  }

  return (
    <>
      <div
        style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}
      >
        <div
          style={{
            background: 'rgb(173 181 189 / 33%)',
            borderRadius: '50%',
            height: '58px',
            width: '58px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <UilLayersAlt style={{ height: '37px', width: '37px' }} />
        </div>
        <div style={{ marginLeft: '15px' }}>
          <h3 style={{ marginBottom: '4px' }}>
            {displayMaterial.material_name}
            {multipleSelectedForMappingCount > 0 && (
              <p style={{ fontSize: '0.8em', color: '#777', margin: 0 }}>
                (+{multipleSelectedForMappingCount} {t('more_selected_suffix')})
              </p>
            )}
          </h3>
        </div>
      </div>
    </>
  )
}

export default MaterialInfo
